var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { RestService } from "../RestService";
const URL = "/dayProgram";
export class DayProgramApi extends RestService {
    getAll(params, active) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(URL, Object.assign(Object.assign({}, params), { active }));
            if (res.ok) {
                return res.data;
            }
            else {
                return null;
            }
        });
    }
    getOne(dayProgramId) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.get(`${URL}/${dayProgramId}`);
            if (res.ok) {
                return res.data;
            }
            else {
                return null;
            }
        });
    }
    createDayProgram(dayProgram) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.post(URL, dayProgram, this.headers.multipart);
            if (res.ok)
                return res.data;
            return null;
        });
    }
    update(dayProgram) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(URL, dayProgram, this.headers.multipart);
            return res.ok;
        });
    }
    delete(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = `${URL}/${id}`;
            const res = yield this.httpClient.delete(url);
            return res.ok;
        });
    }
    deleteActivities(ids) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/deleteActivities`, { ids });
            return res.ok;
        });
    }
    getFavorites(dayProgramIds) {
        return __awaiter(this, void 0, void 0, function* () {
            const url = "favorites";
            const res = yield this.httpClient.get(url, { ids: dayProgramIds });
            if (res.ok)
                return res.data;
            return null;
        });
    }
    updateActivity(ids, newStatus) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/activity`, { ids, newStatus });
            return res.ok;
        });
    }
    updateLikes(id, isLike) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/updateLikes`, { id, isLike });
            return res.ok;
        });
    }
    updateHits(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.httpClient.put(`${URL}/updateHits`, { id });
            return res.ok;
        });
    }
}
//# sourceMappingURL=DayProgramApi.js.map